import { getUserInfo } from './state';

const mutations = {

    /**
   * Удаляет данные о юзере
   *
   * @param {Object} state
   */
    LOGOUT(state) {
        state.AppActiveUser = getUserInfo();
    },

    /**
   * Показать или скрыть overlay при открытии обучение. Overlay - затемнение фона. Прописан условие в Main.vue
   *
   * @param {Object} state - Vuex.state
   * @param {Boolean} bool - показать/скрыть overlay
   */
    TUTORIAL_OVERLAY_TOGGLE(state, bool) {
        state.tutorialOverlayIsShown = bool;
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////
    UPDATE_USER_INFO(state, payload) {
        const userInfo = state.AppActiveUser;

        for (const property of Object.keys(payload)) {
            if (payload[property] != null) {
                // If some of user property is null - user default property defined in state.AppActiveUser
                state.AppActiveUser[property] = payload[property];

                userInfo[property] = payload[property];
            }
        }
    },
};

export default mutations;
